module.exports = "/_next/static/images/platforms-d6bb76a6c674b59de0bb04d7b8152c11.png";